import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartColumn,
  faEnvelope,
  faEye,
} from "@fortawesome/pro-regular-svg-icons";

type ReachStatisticProps = {
  viewCount: number;
  emailDeliveryCount: number;
  reachCount: number;
};

// Reach counter on a post or appointment (#320). Collapsed: statistic icon + unique
// reach (union of platform viewers and email recipients). Click toggles the
// per-channel breakdown; the two raw values may add up to more than the reach because
// members can appear in both channels (digest recipients who click through).
export default function ReachStatistic({
  viewCount,
  emailDeliveryCount,
  reachCount,
}: ReachStatisticProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <button
      type="button"
      className="reach-statistic btn ml-auto flex items-center gap-3 text-sm text-muted px-0"
      onClick={() => setExpanded((current) => !current)}
      title={I18n.t("js.reach.title")}
      aria-expanded={expanded}
    >
      {expanded ? (
        <>
          <span
            className="reach-statistic-views flex items-center gap-1"
            title={I18n.t("js.reach.views_title")}
          >
            <FontAwesomeIcon icon={faEye} />
            {viewCount}
          </span>
          <span
            className="reach-statistic-email-deliveries flex items-center gap-1"
            title={I18n.t("js.reach.email_deliveries_title")}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            {emailDeliveryCount}
          </span>
        </>
      ) : (
        <span className="flex items-center gap-1">
          <FontAwesomeIcon icon={faChartColumn} />
          {reachCount}
        </span>
      )}
    </button>
  );
}
